import { render, staticRenderFns } from "./AreasSupplied.vue?vue&type=template&id=736a2162&"
import script from "./AreasSupplied.vue?vue&type=script&lang=js&"
export * from "./AreasSupplied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports